module.exports = __webpack_public_path__ + "__static/site-1784740481084/img/ant-star2.a7428a30.png";